import { gql } from '@apollo/client'
import { useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useDynamicServiceOrdersState = () => React.useContext(Context) || {}
export const useDynamicServiceOrder = () => useDynamicServiceOrdersState()?.dynamicServiceOrders || []

const QUERY = gql`
  query DynamicServiceOrders($page: Int, $search: String, $sort: DynamicServiceOrderSort) {
    dynamicServiceOrders(page: $page, search: $search, sort: $sort) {
      id
      name
      shareCode
      checklist {
        id
        name
      }
      place {
        id
        name
      }
    }
  }
`

const DynamicServiceOrdersLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: { page: 1, search, sort: { field: field || 'NAME', type } },
    client: serviceOrdersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default DynamicServiceOrdersLoader
